import React from 'react'
import { Layout, PrestadoresList, Search, AdBlock, AdImage } from '../../components';
import "./Prestadores.scss";

const Prestadores = ({ location }) => {

    const emergency = location?.state?.emergency;
    console.log(emergency);

    return (
        <Layout background="#1f2024">
            <div className="prestadores">
                <div className="prestadores__promotion">
                    Encontra un prestador cerca tuyo!
                </div>
                <div className="prestadores__container">
                    <div className="prestadores__filter">
                        <div className="prestadores__filter--text">
                            <h4>Prestadores</h4>
                            <span>350 resultados</span>
                        </div>

                        <div className="prestadores__filter--text">
                            <h5>Disponibilidad</h5>
                            <div>
                                <input type="checkbox" />
                                <span>Mañana</span>
                            </div>
                            <div>
                                <input type="checkbox" />
                                <span>Tarde</span>
                            </div>
                            <div>
                                <input type="checkbox" />
                                <span>Noche</span>
                            </div>
                            <div>
                                <input type="checkbox" checked={emergency} />
                                <span>En todo momento</span>
                            </div>
                        </div>

                        <div className="prestadores__filter--text">
                            <h5>Zona</h5>
                            <div>
                                <input type="checkbox" />
                                <span>Zona sur</span>
                            </div>
                            <div>
                                <input type="checkbox" />
                                <span>Zona norte</span>
                            </div>
                            <div>
                                <input type="checkbox" />
                                <span>Zona oeste</span>
                            </div>
                            <div>
                                <input type="checkbox" />
                                <span>Caba</span>
                            </div>
                        </div>

                        <div className="prestadores__filter--text">
                            <h5>Servicio</h5>
                            <div>
                                <input type="checkbox" />
                                <span>Electricista</span>
                            </div>
                            <div>
                                <input type="checkbox" />
                                <span>Pintor</span>
                            </div>
                            <div>
                                <input type="checkbox" />
                                <span>Diseñador grafico</span>
                            </div>
                            <div>
                                <input type="checkbox" />
                                <span>Arquitecto</span>
                            </div>
                        </div>

                        <div className="prestadores__filter--text">
                            <h5>Reputación</h5>
                            <div>
                                <input type="checkbox" />
                                <span>5 estrellas</span>
                            </div>
                            <div>
                                <input type="checkbox" />
                                <span>4 estrellas</span>
                            </div>
                            <div>
                                <input type="checkbox" />
                                <span>4 estrellas</span>
                            </div>
                            <div>
                                <input type="checkbox" />
                                <span>2 estrellas</span>
                            </div>
                            <div>
                                <input type="checkbox" />
                                <span>1 estrella</span>
                            </div>
                            <div>
                                <input type="checkbox" />
                                <span>Todos</span>
                            </div>
                        </div>

                    </div>
                    <div className="prestadores__cards">
                        <div className="prestadores__search">
                            <Search width="100%" />
                        </div>
                        <PrestadoresList></PrestadoresList>
                    </div>
                </div>
            </div>
        </Layout>

    )
}

export default Prestadores
